import { useState, useEffect } from 'react';
import styles from 'shared/styles/vars.module.scss';

const getSize = () => {
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    };
};

export const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState(getSize);

    useEffect(() => {
        function handleResize() {
            setWindowSize(getSize());
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowSize;
};

export const useIsScreenSizeBiggerThanLarge = () => {
    const { width } = useWindowSize();

    return width > Number(styles.largeScreenMin);
};

export const useIsScreenSizeBiggerThenMedium = () => {
    const { width } = useWindowSize();

    return width > Number(styles.mediumScreenMin);
};

export const useIsMediumScreen = () => {
    const { width } = useWindowSize();

    return width > Number(styles.smallScreenMin) && width <= Number(styles.mediumScreenMin);
};

export const useIsSmallScreen = () => {
    const { width } = useWindowSize();

    return width <= Number(styles.smallScreenMin);
};
